import { CREDO_RAMPUP_FEATURE } from '../constants';
import queryCredoEligibility from './queryCredoEligibility';
const queryCredoRampup = _ref => {
  let {
    store: {
      getState
    },
    store
  } = _ref;
  return queryCredoEligibility({
    store,
    ownProps: {
      feature: CREDO_RAMPUP_FEATURE
    }
  });
};
export default queryCredoRampup;